import { Reveal } from "./Reveal";

const photos = [
  {
    src: "/images/pond-cows.webp",
    alt: "Two Angus cows by the pond under mossy oaks",
    caption: "Pond company under the oaks",
    span: "lg:col-span-7",
  },
  {
    src: "/images/cooler-packed.webp",
    alt: "A full beef share vacuum sealed and labeled on the table",
    caption: "Every share, vacuum sealed & labeled",
    span: "lg:col-span-5",
  },
  {
    src: "/images/pasture-barn.webp",
    alt: "Black Angus standing by the open barn on the farm",
    caption: "Mornings by the barn",
    span: "lg:col-span-5",
  },
  {
    src: "/images/cattle-pair.webp",
    alt: "Steaks cooking over an open wood fire",
    caption: "The payoff — over open fire",
    span: "lg:col-span-7",
  },
  {
    src: "/images/fence-cow.webp",
    alt: "Black Angus cow up close at the fence line",
    caption: "Curious at the fence line",
    span: "lg:col-span-4",
  },
  {
    src: "/images/beef-spread.webp",
    alt: "Heavy-duty cooler packed with vacuum-sealed beef for delivery",
    caption: "Packed in heavy-duty coolers",
    span: "lg:col-span-4",
  },
  {
    src: "/images/butcher-steaks.webp",
    alt: "Fresh-cut steaks vacuum sealed and labeled at North Florida Custom Meats",
    caption: "Fresh cut & labeled at the butcher",
    span: "lg:col-span-4",
  },
];

export const Gallery = () => (
  <section className="py-24 lg:py-32 bg-white border-y border-linen" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
        <div>
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-clay mb-4">From Our Herd</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-tight max-w-xl">
            Real animals. Real beef. Real freezers filled.
          </h2>
        </div>
        <p className="text-moss text-base leading-relaxed max-w-sm">
          No stock photos here — this is our cattle, our butcher's work, and our customers' shares.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {photos.map((p, i) => (
          <Reveal key={p.src} delay={i * 0.1} className={p.span}>
            <figure className="group relative overflow-hidden rounded-2xl border border-linen" data-testid={`gallery-photo-${i}`}>
              <img
                src={p.src}
                alt={p.alt}
                className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent px-6 pb-5 pt-14">
                <span className="text-cream font-display italic text-lg">{p.caption}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
